/* global SearchEnabled */

import React from 'react';
import classNames from 'classnames';
import Icon from 'components/Icon';
import { helperGetFindUrl } from 'helpers/RouteHelper';
import { getOptimizelySearchBoxEnabled } from 'helpers/OptimizelyHelper';
import HeaderLink from '../HeaderLink';
import style from './SearchIcon.module.scss';

const SearchIcon = ({ onClick, isActive }) => {
  if (!SearchEnabled) return null;
  const icon = <Icon icon="search" ariaHidden />;
  const searchIconClasses = [
    style.rightIcon,
    style.searchIcon,
    isActive && style.active,
    getOptimizelySearchBoxEnabled() ? style.displaySearchIcon : null,
  ];

  const props = {
    className: classNames(searchIconClasses),
    key: 'headerSearchIcon',
    onClick,
    'aria-label': 'search the site',
    to: helperGetFindUrl(),
  };
  return HeaderLink(props, icon);
};

export default SearchIcon;
